import { useEffect, useRef } from 'react';
import { useTimeRangeStore } from '@/store/app.store';

/** Fires when a preset becomes the selected range, so a page can clear its filters. */
export function useOnPresetSelected(onSelected: () => void) {
  const { timeRange } = useTimeRangeStore();
  // Not the mount run: the default range is a preset, so firing there would clear
  // filters a page had just read out of the url.
  const previous = useRef(timeRange);

  useEffect(() => {
    if (previous.current === timeRange) return;
    previous.current = timeRange;
    if (timeRange) onSelected();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange]);
}
